@if (icon()) {
  <ui-icon [icon]="icon()!" [size]="20" />
} @else if (text()) {
  <span class="text-base font-medium">{{ text() }}</span>
} @else if (list() && selectedItem()) {
  <div
    class="form-field-addon-menu-trigger"
    [ngClass]="{ 'form-field-addon-menu-trigger-disabled': list()!.disabled }"
    (click)="openMenu($event)"
    [matMenuTriggerFor]="list()!.disabled ? null : menu"
    [matMenuTriggerData]="{ yPosition: 'below', overlapTrigger: false }">
    <span class="text-base font-medium">{{ selectedItem()!.label }}</span>
    <ui-icon icon="griddy-chevron-down" [size]="16" />
  </div>

  <mat-menu #menu="matMenu">
    @for (item of list()!.items; track item.label) {
      <span mat-menu-item (click)="list()!.onChange(item.value)">{{ item.label }}</span>
    }
  </mat-menu>
}
